module.exports = __webpack_public_path__ + "img/chess-pawn-piece.f4a276d6.svg";